import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Title } from "@/components/ui/title";
import { ChevronLeft, CirclePlus } from "lucide-react";

const Biometrics = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-blue-50 p-8">
      <div className="flex items-center justify-between py-2">
        <Button variant="link" onClick={() => navigate("/")}>
          <ChevronLeft size={16} /> Back
        </Button>

        <Title
          as="h1"
          className="absolute left-1/2 -translate-y-1/2 transform font-semibold"
        >
          All Biometrics
        </Title>
        <CirclePlus className="text-primary hover:text-primary-dark" />
      </div>
      <div defaultValue="notifications" className="rounded-2xl bg-white p-6">
        <div className="mx-auto max-w-4xl space-y-6 p-6">
          <Card className="add-class border-0 shadow-none">
            <CardContent>
              <div className="flex flex-col gap-4 md:flex-row">
                <p>
                  No biometric data Found. Please click &apos; + &apos; icon to
                  add biometrics.
                </p>
              </div>
            </CardContent>
            <CardFooter>
              <p className="text-sm font-medium leading-none">
                Footer Section goes here
              </p>
            </CardFooter>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Biometrics;
